module.exports = {
  CloseProject: 'ปิดโครงการ',
  RebuildProject: 'เปิดโครงการใหม่',
  ProjectNo: 'เลขที่โครงการ',
  CustomerName: 'ชื่อลูกค้า',
  ProjectStatus: 'สถานะโครงการ',
  ProjectName: 'ชื่อโครงการ',
  ProjectCycle: 'ระยะเวลาโครงการ',
  ProjectManager: 'ผู้จัดการโครงการ',
  ProjectDepartment: 'แผนกโครงการ',
  ProjectOffice: 'บริษัทโครงการ',
  ExpectIncome: 'รายได้ประมาณการ',
  ExpectCost: 'ต้นทุนประมาณการ',
  ExpectExpense: 'ค่าใช้จ่ายประมาณการ',
  RealIncome: 'รายได้จริง',
  RealCost: 'ต้นทุนจริง',
  RealExpense: 'ค่าใช้จ่ายจริง',
  SettleCurrency: 'สกุลเงินในการคำนวณ',
  Remarks: 'คำอธิบายโครงการ',
  ExpectTotalCost: 'ค่าใช้จ่ายรวมประมาณการ',
  RealTotalCost: 'ค่าใช้จ่ายรวมจริง',
  ExpectProfitTate: 'อัตรากำไรประมาณการ',
  RealProfitTate: 'อัตรากำไรจริง',
  ReceiveStatus: 'สถานะการรับเงิน',
  PayStatus: 'สถานะการจ่ายเงิน',
  StartDate: 'วันที่เริ่มต้น',
  EndtDate: 'วันที่สิ้นสุด'
}
